<template>
  <PartnershipProgrammerSection ref="partnershipProgrammer"></PartnershipProgrammerSection>
</template>

<script>
  import PartnershipProgrammerSection from "./PartnershipProgrammerSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "PartnershipProgrammerWrapper",
    components: {
      PartnershipProgrammerSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
